export default "<div class=\"wrap\">\n    <app-tabela-preco></app-tabela-preco>\n</div>\n"